import { ClaimRequest, ClaimResponse, ClaimValidationRequest, ClaimValidationSuccessResponse } from '@ecocart/entities';
import { apiCall, CLAIMS_API } from './api';

export const validateClaim = (claim: ClaimValidationRequest): Promise<ClaimValidationSuccessResponse> => {
  return apiCall<ClaimValidationSuccessResponse>('POST', `${CLAIMS_API}/claims/validate`, claim);
};

export const submitClaim = (claim: ClaimRequest): Promise<{ data: ClaimResponse }> => {
  return apiCall<{ data: ClaimResponse }>('POST', `${CLAIMS_API}/claims`, claim);
};
